// const $window = $(window);
// let windowWidth = $window.width();
// var _isTest = false;

// // メディアクエリ
// let mql = window.matchMedia('screen and (max-width: 1024px)');

//pageTop
import {pageTop} from "../include/module";
pageTop();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();


$(window).on('load' , function() {

  scrollAnime();

});



// ------------------------------------------------------------------------
// scrollAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollAnime = () => {

  const controller = new ScrollMagic.Controller();

  //ページトップ出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-Story',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle('#st-Top', 'st-Top-Show')
  .addTo(controller);

};


// WEBPACK FOOTER //
// ./src/assets/js/privileges/script.js